export function addFolder(name, updateActiveFolder) {
  return {
    type: 'ADD_FOLDER',
    name,
    updateActiveFolder,
  };
}

export function removeFolder(id) {
  return {
    type: 'REMOVE_FOLDER',
    id,
  };
}

export function selectFolder(id) {
  return {
    type: 'SELECT_FOLDER',
    id,
  };
}

export function updateFolder(id, name) {
  return {
    type: 'UPDATE_FOLDER',
    id,
    name,
  };
}

function selectSavedFoldersFromState(state) {
  return state.favorites.folders.savedFolders;
}

export function saveItems(items, itemType, folderId) {
  return (dispatch, getState) => {
    const state = getState();
    const savedFolders = selectSavedFoldersFromState(state);

    dispatch({
      type: 'SAVE_ITEMS',
      savedFolders,
      items,
      itemType,
      folderId,
    });
  };
}

export function removeItems(items, itemType, folderId) {
  return (dispatch, getState) => {
    const state = getState();
    const savedFolders = selectSavedFoldersFromState(state);

    dispatch({
      type: 'REMOVE_ITEMS',
      savedFolders,
      items,
      itemType,
      folderId,
    });
  };
}

export function dontShow(value) {
  return {
    type: 'DONT_SHOW',
    value,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/favorites.js